import { SsrService } from '@/common/services/ssr/ssr.service';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fe-cookie-consent',
    templateUrl: './cookie-consent.component.html',
    styleUrls: ['./cookie-consent.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class CookieConsentComponent implements OnInit {
    showCookieModal = false;
    showMoreInfo = false;

    constructor(public ssr: SsrService) {}
    ngOnInit(): void {
        this.showCookieModal = !this.isCookieConsentDismissed();
    }

    closeNotice(): void {
        this.showCookieModal = false;
        this.setCookieConsentDismissed(true);
    }

    showModal(): void {
        this.showMoreInfo = true;
    }

    closeMoreInfo(): void {
        this.showMoreInfo = false;
    }

    private isCookieConsentDismissed(): boolean {
        if (this.ssr.isPlatformServer()) {
            return true;
        }
        return localStorage.getItem('cookieConsentDismissed') === 'true';
    }

    private setCookieConsentDismissed(value: boolean): void {
        localStorage.setItem('cookieConsentDismissed', String(value));
    }
}
